interface BulkImportFlowArtifactProps {
  systemLabel: string;
  /** Shown before a CSV is loaded — uses Figma empty-state card styling. */
  noCsv?: boolean;
  onOpen?: () => void;
}

export function BulkImportFlowArtifact({
  systemLabel,
  noCsv = false,
  onOpen,
}: BulkImportFlowArtifactProps) {
  const interactive = Boolean(onOpen);
  const className = [
    'bulk-import__artifact',
    noCsv ? 'bulk-import__artifact--no-csv' : '',
    interactive ? 'bulk-import__artifact--interactive' : '',
  ]
    .filter(Boolean)
    .join(' ');

  if (interactive) {
    return (
      <button
        type="button"
        className={className}
        aria-label="Open bulk add users panel"
        onClick={onOpen}
      >
        <h2 className="bulk-import__artifact-title">Bulk add users</h2>
        <p className="bulk-import__artifact-system">{systemLabel}</p>
      </button>
    );
  }

  return (
    <div className={className} aria-label="Bulk add users workflow">
      <h2 className="bulk-import__artifact-title">Bulk add users</h2>
      <p className="bulk-import__artifact-system">{systemLabel}</p>
    </div>
  );
}
